import React from "react";
import "./Common_Btn_Yellow.css";

function Common_Btn_Yellow({ text, onClick,type }) {
  return (
    <div className="btn_wrapper">
      <button className="btn_text" type={type ? type : "button"} onClick={onClick}>
        {text}
      </button>
    </div>
  );
}

export default Common_Btn_Yellow;